import { getCmsDestinationsAction } from "../../../Actions/LogicActions/CmsDestination/GetCmsDestinationsActon";
import { destinationsDicoverClickAction } from "../../../Actions/UIActions/CMSDestination/DestinationsDicoverClickAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { IGetDestinationActionParams } from "../../../Orchestrator/Types/Interface/ICmsDestination";

class DestinationsInitStep extends StepFlow {
  get stepName() {
    return "DestinationsInit_Step";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on<void, void>({
        eventName: evtTree.Destinations.Get,
        handler: async ({}) => {
          await getCmsDestinationsAction.execute();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IGetDestinationActionParams, void>({
        eventName: evtTree.Destinations.Discover.Click,
        handler: async (data) => {
          destinationsDicoverClickAction.setParams(data.data!);
          await destinationsDicoverClickAction.execute();
        },
      })
    );
  }

  async onExecute(): Promise<void> {
    console.log("Destinations Init Step Execute...");
    _eventBus.emit({
      eventName: evtTree.Destinations.Get,
    });
    // Execute the action to fetch CMS destinations
  }
}

export const DestinationsInitStepDeclaration = new StepDefinition({
  stepName: "DestinationsInit_Step",
  stepClass: DestinationsInitStep,
});
